import React from 'react';
const POINTS = [{
  icon: '🔧',
  title: 'Practical visual references',
  body: 'Find the symptom, component, test, or troubleshooting path you need while diagnosing home appliances.'
}, {
  icon: '🔍',
  title: 'Structured fault-finding system',
  body: 'Move from symptoms and possible causes to checks, component testing, comparisons, and fault isolation.'
}, {
  icon: '⚡',
  title: '6 diagnostic areas',
  body: 'Diagnostic fundamentals, refrigerators, washing machines, dryers, dishwashers, ovens, and ranges.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  body: 'Return to the system whenever you need to identify, check, test, compare, or troubleshoot an appliance fault.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-8" data-id="element-102" data-mp="1ygvvw13cc5r2">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-103" data-mp="1yi6zo0wsddi6">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-104" data-mp="23f7467dzm876">
          This isn't just another appliance repair ebook
        </h2>
        <p className="mt-1 text-center font-display text-base font-extrabold uppercase leading-tight text-electric sm:text-2xl" data-id="element-105" data-mp="2esd2fh550vpt">
          It's a ready-to-use visual diagnostic system.
        </p>

        <div className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-106" data-mp="251if09g5nq2s">
          {POINTS.map(point => <div key={point.title} className="flex gap-3 rounded-lg border border-navyline bg-navydeep p-3.5" data-id="element-107" data-mp="203yy11s2oz75">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-108" data-mp="2sqjpe28jtbap">
                {point.icon}
              </span>
              <div data-id="element-109" data-mp="2nqf5e28flyfq">
                <h3 className="text-[15px] leading-tight text-white sm:text-base" data-id="element-110" data-mp="2npx42r6wwu0y">
                  {point.title}
                </h3>
                <p className="mt-1 text-sm leading-snug text-steel" data-id="element-111" data-mp="1ccbfp88vmwgh">{point.body}</p>
              </div>
            </div>)}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase tracking-wide text-white sm:text-xl" data-id="element-112" data-mp="189eqgyou023k">
          Less searching. Less guessing.{' '}
          <span className="text-electric" data-id="element-113" data-mp="1erhxfhzee70x">More diagnostic clarity.</span>
        </p>
      </div>
    </section>;
}